import React from 'react';
import { GridItem, Wrapper } from './ProductGrid.styles';

export type ProductGridProps = {
  gridItems: JSX.Element[];
};
/**
 * A wrapper to create a grid of items. The grid has 4 columns on desktop, 3 on tablet, and 2 on mobile.
 */
const ProductGrid: React.FC<ProductGridProps> = (props: ProductGridProps) => {
  const { gridItems } = props;
  return (
    <Wrapper>
      {gridItems.map((item, i) => (
        <GridItem key={`grid-item-${i}`}>{item}</GridItem>
      ))}
    </Wrapper>
  );
};

export default ProductGrid;
